import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { apiClient } from "../../api";

import { GET_FLIGHTS_API_RESPONSE } from "./types";
import keys from "./keys";

export const flightsResourcePath = "flights/businesses/:businessId";

export const useGetFlights = (businessId: string, url: string) => {
  const flightUrl = url.replace(":businessId", businessId);

  const hash = [keys.read, flightUrl];
  const {
    isLoading,
    data,
    isSuccess,
    error,
  }: UseQueryResult<GET_FLIGHTS_API_RESPONSE, unknown> = useQuery(
    hash,
    () => apiClient.get({ url: flightUrl }),
    {
      enabled: !!businessId,
    },
  );

  return { isLoading, data, isSuccess, error };
};
